"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionHrefLangMap = exports.RegionFallbackLanguageMap = exports.LanguageDisplayNameMap = exports.Language = void 0;
const region_1 = require("./region");
var Language;
(function (Language) {
    Language["en"] = "en";
    Language["id"] = "id";
    Language["ja"] = "ja";
    Language["ms"] = "ms";
    Language["th"] = "th";
    Language["vi"] = "vi";
    Language["fil"] = "fil";
})(Language = exports.Language || (exports.Language = {}));
exports.LanguageDisplayNameMap = {
    en: 'English',
    id: 'Bahasa Indonesia',
    ja: '日本語',
    ms: 'Bahasa Melayu',
    th: 'ไทย',
    vi: 'Tiếng Việt',
    fil: 'Pilipino',
};
exports.RegionFallbackLanguageMap = {
    [region_1.Region.jp]: Language.ja,
    [region_1.Region.th]: Language.th,
    [region_1.Region.my]: Language.ms,
    [region_1.Region.id]: Language.id,
    [region_1.Region.vn]: Language.vi,
    [region_1.Region.us]: Language.en,
    [region_1.Region.gb]: Language.en,
    [region_1.Region.sg]: Language.en,
    [region_1.Region.ph]: Language.en,
};
exports.RegionHrefLangMap = {
    [region_1.Region.jp]: 'ja-jp',
    [region_1.Region.th]: 'th-th',
    [region_1.Region.my]: 'ms-my',
    [region_1.Region.id]: 'id-id',
    [region_1.Region.vn]: 'vi-vn',
    [region_1.Region.us]: 'en-us',
    [region_1.Region.gb]: 'en-gb',
    [region_1.Region.sg]: 'en-sg',
    [region_1.Region.ph]: 'en-ph',
};
